<div class="scrollable" [style.height]="scrollHeightSignal() + 'px'" (scroll)="appService.closeAllTooltips()">
  <div class="w-100 ltr flex flex-col gap-2.5">
    <div class="flex flex-col gap-2.5">
      <app-options-button
        [settings]="settings"
        settingOption="finishing"
        (optionSelect)="settingOptionSelected($event)"
      ></app-options-button>
      <!-- HUECO -->
    </div>
  </div>
</div>

<!-- BOTONES DE ABAJO -->

<div
  *ngIf="!appService.isMobile()"
  class="fixed-footer"
  (elementResize)="fixedFooterDesktopHeight.set($event)"
  #fixedFooterDesktop
>
  <ion-button class="goToFinishingButton" (click)="goToGeneralSettings()">
    <ion-icon src="assets/icon/arrow-left.svg" class="arrow-icon"></ion-icon>
    <div class="button-content">
      <span class="span-content">Configura la impresión</span>
    </div>
  </ion-button>
</div>

<div
  *ngIf="appService.isMobile()"
  class="floatting flex flex-col"
  (elementResize)="fixedFooterMobileHeight.set($event)"
  #fixedFooterMobile
>
  <ion-button class="goToFinishingButtonMobile w-100" (click)="goToGeneralSettings()">
    <ion-icon src="assets/icon/arrow-left.svg"></ion-icon>
    Configura la impresión de esta carpeta
  </ion-button>
  <ion-button color="tertiary" class="goToFinishingButton w-100" (click)="closeSettings()">
    Confirmar ajustes
    <ion-icon src="assets/icon/arrow-right.svg"></ion-icon>
  </ion-button>
</div>
